/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

// override to fix the ootb issue, when select pick-up and save without select/display the default billing address
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    UpdateSession,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";

type HandlerType = Parameters<typeof UpdateSession>[0];

export const CustomUpdateSession = (props: HandlerType) => {
    const state = props.getState();
    const session = state.context.session;
    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: {
            ...session,
            email: props.apiResult.email,
            userName: props.apiResult.userName,
            properties: {
                ...session.properties,
                defaultBillToId:
                    state.pages.accountSettings.selectedBillToId ??
                    session.properties.defaultBillToId,
            },
        },
    });
};

replaceInChain(chain, UpdateSession, CustomUpdateSession);
